// extracted by mini-css-extract-plugin
export default {"justInSubCategoriesStack":"JustInSubCategoriesPage_justInSubCategoriesStack__i1SVM"};